import merge from "lodash.merge"
import * as querystring from "querystring"
import { DISCOVER, ERRORLIST, TIMEROUT, ITC } from "../../util/eventTypes"
import BaseEvent from "../../util/baseEvent"
// 消息超时时间
const RESEIVE_MESSAGE_TIMEOUT = TIMEROUT.RESEIVE_MESSAGE_TIMEOUT // 3000
// 报活频率
const KEEAP_INTERVAL_TIME = TIMEROUT.KEEAP_INTERVAL_TIME // 5000
// 报活失败次数
const MAX_KEEPALIVE_ERROR_COUNT = TIMEROUT.MAX_KEEPALIVE_ERROR_COUNT // 3
// 不需要记录日志的msgid
const NEEDLESS_RECORD_LOG_MSGIDS = ["15", "16"]
// socket 链接超时
const SOCKET_CONNECTING_TIMEOUT = 5000
/**
 * 错误消息类型 SUCCESS CONNECTING EXCEPTION_CLOSED SELF_CLOSED TIMEOUT SERVERERROR
 **/
class CreateSocket extends BaseEvent {
  constructor(config) {
    super()
    this.$logger.setPrefix("createsocket")
    this.env = config.env
    this.roomid = config.roomid
    this.userid = config.userid
    this.role = config.role
    this.alias = config.alias
    this.product = config.product
    this.usernum = 0
    this.token = config.token
    this.socket = ""
    // 报活失败次数
    this.keepAliveErrorCount = 0
    // 当前房间连接连接次数;
    this.connectCount = 0
    // 发送待处理消息
    this.sendPendingQueue = {}
    // 报活轮训句柄
    this.$tKeepAlive = ""
    // callback回调函数句柄
    this.seqNum = 0
    this.keepaliveExternalInfo = {}
    this.wsAddress = ""
    this.onopen = this.onopen.bind(this)
    this.onmessage = this.onmessage.bind(this)
    this.onerror = this.onerror.bind(this)
    this.onclose = this.onclose.bind(this)
    this.watchRoomStatus()
  }
  // 执行连接
  connect(wsAddress, connectCount) {
    this.wsAddress = wsAddress
    this.connectCount = connectCount
    if (this.socket && this.socket.readyState === 1) {
      return
    }
    let socketParams = querystring.stringify({
      token: this.token,
      uid: this.userid,
      rid: this.roomid,
      product: this.product
    })
    this.debug("==================连接ws============")
    let socketUrl = `wss://${wsAddress}/?${socketParams}`
    let socket
    socket = this.socket = new WebSocket(socketUrl)
    this.timeoutHandler = this.checkConnectingTimeout(SOCKET_CONNECTING_TIMEOUT)
    // 连接中...

    this.$logger.info(DISCOVER.WS_CONNECT_0, {
      status: "connecting"
    })
    socket.addEventListener("open", this.onopen)
    socket.addEventListener("message", this.onmessage)
    socket.addEventListener("error", this.onerror)
    socket.addEventListener("close", this.onclose)
  }
  checkConnectingTimeout(ms) {
    const socket = this.socket
    return window.setTimeout(() => {
      if (socket && socket.readyState === WebSocket.CONNECTING) {
        socket.close(4100, "SOCKET_CONNECTING_TIMEOUT")
      }
    }, ms)
  }
  onopen(e) {
    this.debug("Socket opened:", e)
    this.$logger.info(DISCOVER.WS_CONNECT_1, {
      status: "connected"
    })
    this.sendEnterRoom()
      .then(data => {
        return this.pullPresentRoomInfo().catch(thrown => {
          this.eventEmitter.emit(ITC.ERROR, "GET_INITROOMINFO_FAIL", {
            ws: this.wsAddress,
            code: thrown.message
          })
        })
      })
      .catch(err => {
        const msg = err ? err.message || String(err) : ""
        this.eventEmitter.emit(ITC.ERROR, "SEND_ENTER_ROOM_FAIL", {
          ws: this.wsAddress,
          code: msg
        })
      })
      .then(roomInfo => {
        if (roomInfo) {
          this.eventEmitter.emit(ITC.CONNECTED, roomInfo, this.wsAddress)
          this.saveOnlineUserNum(roomInfo)
        }
      })
  }
  onmessage(res) {
    let data = {}
    try {
      data = JSON.parse(res.data)
    } catch (ex) {
      this.error("【websocket】异常消息返回:", res, ex)
    }
    this.handleResponse(data)
  }
  onclose(code, message) {
    this.error("Socket closed:", code, message)
    this.stopKeepAlive()
    window.clearTimeout(this.timeoutHandler)
    let status = ERRORLIST.SOCKET_CLOSE
    if (code === 4100) {
      status = ERRORLIST.SOCKET_ERROR
    }
    this.eventEmitter.emit(ITC.ERROR, status, {
      host: this.wsAddress,
      error_msg: message,
      event_steps: "connect_socket"
    })
    this.removeSocketListeners()
  }
  onerror(err, message) {
    this.debug("Socket error:", err, message)
    // 记录日志
    window.clearTimeout(this.timeoutHandler)

    this.$logger.error(DISCOVER.WS_CONNECT_2, {
      host: this.wsAddress,
      error_msg: message,
      event_steps: "connect_socket"
    })
    this.removeSocketListeners()
  }
  // 监听教室的状态
  watchRoomStatus() {
    // 200 201成功后emit DISCOVER.CONNECTED事件
    this.eventEmitter.on(ITC.CONNECTED, () => {
      this.keepAlive()
    })
    // 如果执行重连 尝试关闭掉socket连接 待处理队列中只保持业务消息(203,202,208) 其他全部清理掉
    this.eventEmitter.on(ITC.ERROR, () => {
      return this.closeSocket("close")
    })
  }
  // 发送进教室消息
  sendEnterRoom() {
    return new Promise((resolve, reject) => {
      // 发送200消息进入教室 超时时间5S
      this.sendMessage(
        { msgid: "200" },
        (data, code) => {
          if (code === "SUCCESS") {
            this.$logger.info(DISCOVER.RESEIVE_200_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(DISCOVER.RESEIVE_200_FAIL, data)
            reject(data)
          }
        },
        5000
      )
    })
  }
  // 发送获取教室房间信息
  pullPresentRoomInfo() {
    // 发送201消息 获取房间信息 超时时间5S
    return new Promise((resolve, reject) => {
      this.sendMessage(
        { msgid: "201" },
        (res, code) => {
          if (code === "SUCCESS") {
            let data = res["msg"]["data"]
            this.$logger.info(DISCOVER.RESEIVE_201_SUCCESS, data)
            resolve(data)
          } else {
            this.$logger.error(DISCOVER.RESEIVE_201_FAIL, res)
            reject(res)
          }
        },
        5000
      )
    })
  }
  // 报活
  doKeepalive(localping, fullping) {
    let params = {
      msgid: "15",
      localping,
      fullping,
      extend: JSON.stringify(this.keepaliveExternalInfo)
    }
    return new Promise((resolve, reject) => {
      this.sendMessage(params, (res, code) => {
        if (code === "SUCCESS") {
          resolve()
          this.eventEmitter.emit(
            "KEEP_ALIVE_DEALYTIME",
            Date.now() - res.reqtimestamp.split("_")[0]
          )
        } else {
          if (code === "TIMEOUT") {
            this.eventEmitter.emit("KEEP_ALIVE_FAIL", code)
          }
          this.$logger.error(DISCOVER.RESEIVE_15_FAIL, res)
          reject(res)
        }
      })
    })
  }
  /**
   *开始报活
   * 先发送fullping消息获取到消息类型
   **/
  keepAlive() {
    let $vm = this
    this.$tKeepAlive = setInterval(() => {
      if ($vm.keepAliveErrorCount >= MAX_KEEPALIVE_ERROR_COUNT) {
        $vm.eventEmitter.emit(ITC.ERROR, ERRORLIST.KEEPALIVE_FAIL, {
          host: this.wsAddress,
          event_steps: "connect_socket"
        })
        return
      }
      // 每个5秒报活 并且 获取用户数
      $vm
        .doKeepalive("0", "0")
        .then(() => {
          $vm.keepAliveErrorCount = 0
        })
        .catch(err => {
          $vm.keepAliveErrorCount += 1
        })
    }, KEEAP_INTERVAL_TIME)
  }
  /**
   * 销毁信令
   **/
  stopKeepAlive(data) {
    this.debug("stop keepalive,")
    this.$tKeepAlive && clearInterval(this.$tKeepAlive)
    this.keepAliveErrorCount = 0
    this.$tKeepAlive = null
  }
  addKeepliveInfo(params) {
    this.keepaliveExternalInfo = merge(this.keepaliveExternalInfo, params)
  }
  /**
   * 发送消息内容
   **/
  sendMessage(
    params,
    callback = (data, code) => {},
    delayTime = RESEIVE_MESSAGE_TIMEOUT
  ) {
    if (!params.hasOwnProperty("msgid")) {
      callback({}, "FORMAT_ERROR")
      return
    }
    // 如果当前socket的连接状态是不是1
    if (!this.socket || this.socket.readyState !== 1) {
      return
    }
    let timestamp = `${new Date().getTime()}_${this.seqNum}`
    // callback句柄+1
    this.seqNum += 1
    // 如果param中不包含timestamp表示不是重试消息  需要手动拼装数据
    let newParams = merge(
      {
        usernum: String(this.usernum),
        userid: String(this.userid),
        roomid: String(this.roomid),
        role: String(this.role),
        alias: String(this.alias),
        timestamp,
        product: String(this.product),
        msg: {
          userid: String(this.userid),
          roomid: String(this.roomid),
          role: String(this.role),
          alias: String(this.alias)
        }
      },
      params
    )
    let $t
    $t = setTimeout(() => {
      // 没有收到回复
      callback(newParams, "TIMEOUT")
      delete this.sendPendingQueue[timestamp]
      if (!params.msg || !params.msg.msgtype) return
      const logData = {
        msgid: params.msgid,
        msgtype: params.msg.msgtype,
        timestamp,
        data: JSON.stringify(params.msg.data)
      }
      // RTT统计
      // this.eventEmitter.emit(
      //   LOG.ERROR,
      //   "message_timeout",
      //   {
      //     host: this.wsAddress,
      //     event_steps: "connect_socket",
      //     msg_number: parseInt(params.msgid) || 0,
      //     messageType: params.msg.msgtype || "",
      //     sid: timestamp,
      //     data: JSON.stringify(logData)
      //   },
      //   true
      // )
      this.$logger.error("message_timeout", {
        host: this.wsAddress,
        event_steps: "connect_socket",
        msg_number: parseInt(params.msgid) || 0,
        messageType: params.msg.msgtype || "",
        sid: timestamp,
        data: JSON.stringify(logData)
      })
    }, delayTime)
    this.sendPendingQueue[timestamp] = {
      msgid: newParams.msgid,
      params: newParams,
      callback: callback,
      tHandle: $t
    }
    this.socket.send(JSON.stringify(newParams))
  }
  // 处理回应消息
  handleResponse(data) {
    let newData = merge({ msg: {} }, data)
    let {
      msgid,
      msg: { srcmsgid }
    } = newData
    // 如果服务端返回错误消息
    // 如果接收到的被踢消息 手动执行处理销毁
    // 如果接收到的是回应消息 单独处理
    // 如果接收到的是别人发送过来的消息 直接吐出
    if (newData.hasOwnProperty("errno")) {
      let { errno, description } = newData
      // 这一块指带token出错
      this.handleServerException(errno, description)
      this.$logger.error("-105", description)
    } else if (msgid === "400") {
      // 这里主要处理400踢人消息
      this.kickOff()
      this.$logger.error("400", "kickOff")
    } else if (msgid === "202") {
      let res = newData.result[0]
      if (
        res === -101 ||
        res === -102 ||
        res === -103 ||
        res === -104 ||
        res === -105 ||
        res === -106 ||
        res === -107
      ) {
        // ws主动断开连接
        this.eventEmitter.emit(ITC.CLOSE, res)
        this.$logger.error("ws_close", res)
      } else {
        // 这里主要处理200,201，203等等消息
        this.handleReply(newData)
      }
    } else {
      // 这里主要处理15报活，获取学生数等等消息
      this.eventEmitter.emit(ITC.MESSAGE, newData)
      // 如果这条数据需要记录日志 那就记录日志信息
      if (NEEDLESS_RECORD_LOG_MSGIDS.indexOf(srcmsgid) === -1) {
        // RTT统计
        // this.eventEmitter.emit(
        //   LOG.INFO,
        //   "receive_message",
        //   {
        //     host: this.wsAddress,
        //     event_steps: "connect_socket",
        //     msg_number: parseInt(newData.msgid) || 0,
        //     messageType: newData.msg.msgtype || "",
        //     sid: newData.timestamp,
        //     fromStartTime: "0",
        //     responsetime: Date.now() + "",
        //     num1: this.usernum,
        //     // 208data内容项太长不记录
        //     data: newData.msgid !== "208" ? JSON.stringify(newData) : ""
        //   },
        //   true
        // )
        this.$logger.info("receiveMessage", {
          host: this.wsAddress,
          event_steps: "connect_socket",
          msg_number: parseInt(newData.msgid) || 0,
          messageType: newData.msg.msgtype || "",
          sid: newData.timestamp,
          fromStartTime: "0",
          responsetime: Date.now() + "",
          num1: this.usernum,
          // 208data内容项太长不记录
          data: newData.msgid !== "208" ? JSON.stringify(newData) : ""
        })
      }
      this.handleReply(newData)
    }
  }
  handleServerException(errno, description) {
    switch (errno) {
      case -101:
        this.eventEmitter.emit(ITC.CLOSE, description || "101")
        break
      case -102:
        this.eventEmitter.emit(ITC.CLOSE, description || "102")
        break
      case -103:
        this.eventEmitter.emit(ITC.CLOSE, description || "103")
        break
      case -104:
        this.eventEmitter.emit(
          ITC.CLOSE,
          description || ERRORLIST.KEEPALIVE_FAIL
        )
        break
      case -105:
        this.eventEmitter.emit(ITC.CLOSE, description || ERRORLIST.TOKEN_ERROR)
        break
      case -106:
        this.eventEmitter.emit(ITC.CLOSE, description || "106")
        break
      case -107:
        this.eventEmitter.emit(ITC.CLOSE, description || "107")
        break
      default:
        break
    }
  }
  // 被踢
  kickOff() {
    this.eventEmitter.emit(ITC.CLOSE, ERRORLIST.KICKOFF)
  }
  // 成功后回调
  handleReply(res) {
    let { result } = res
    let reqtimestamp = res.reqtimestamp || res.timestamp
    if (!this.sendPendingQueue.hasOwnProperty(reqtimestamp)) {
    } else {
      let { callback, tHandle, params } = this.sendPendingQueue[reqtimestamp]
      // RTT统计
      if (NEEDLESS_RECORD_LOG_MSGIDS.indexOf(params.msgid) === -1) {
        let curTime = new Date().getTime()
        let orginSendTime = Number(reqtimestamp.split("_")[0])
        // this.eventEmitter.emit(
        //   LOG.INFO,
        //   "sent_message",
        //   {
        //     event_steps: "connect_socket",
        //     host: this.wsAddress,
        //     msg_number: parseInt(params.msgid) || 0,
        //     messageType: params.msg.msgtype || "",
        //     fromStartTime: orginSendTime + "",
        //     sid: reqtimestamp,
        //     responsetime: curTime + "",
        //     num1: this.usernum
        //   },
        //   true
        // )
        this.$logger.info("sent_message", {
          event_steps: "connect_socket",
          host: this.wsAddress,
          msg_number: parseInt(params.msgid) || 0,
          messageType: params.msg.msgtype || "",
          fromStartTime: orginSendTime + "",
          sid: reqtimestamp,
          responsetime: curTime + "",
          num1: this.usernum
        })
      }
      // 删除超时定时器
      clearTimeout(tHandle)
      if (result[0] === 0) {
        callback(res, "SUCCESS")
      } else {
        callback(result[0], "ERROR")
      }
      this.saveOnlineUserNum(res)
      delete this.sendPendingQueue[reqtimestamp]
    }
  }
  closeSocket(data) {
    this.stopKeepAlive(data)
    return new Promise((resolve, reject) => {
      // 如果信令已经完全断开
      if (!this.socket || (this.socket && this.socket.readyState === 3)) {
        resolve("closed")
        return
      }
      let $t
      this.removeSocketListeners()
      this.socket.addEventListener("close", code => {
        $t && clearTimeout($t)
        this.socket = null
        resolve("closed")
      })
      this.socket.close(3100)
      $t = setTimeout(() => {
        reject(new Error("关闭socket失败！"))
      }, 5000)
    })
  }
  saveOnlineUserNum(data) {
    if (!data.msg) return
    const srcmsgid = data.msg.srcmsgid
    if (isNaN(parseInt(data.msg.online_usernum, 10))) {
      return
    }
    this.debug(`Got online_usernum from `, data)
    this.usernum = data.msg.online_usernum
  }
  removeSocketListeners() {
    if (this.socket) {
      this.socket.removeEventListener("open", this.onopen)
      this.socket.removeEventListener("message", this.onmessage)
      this.socket.removeEventListener("error", this.onerror)
      this.socket.removeEventListener("close", this.onclose)
    }
  }
  /**
   * 销毁信令
   * 销毁所有发送消息的回调函数
   * 清空报活相关操作
   **/
  destroy(data) {
    this.seqNum = 0
    for (let i in this.sendPendingQueue) {
      if (this.sendPendingQueue.hasOwnProperty(i)) {
        let $t = this.sendPendingQueue[i]["$t"]
        $t && clearTimeout($t)
      }
    }
    this.sendPendingQueue = {}
    return this.closeSocket(data)
  }
}
export default CreateSocket
// # sourceMappingURL=createSocket.js.map
